module.exports = __webpack_public_path__ + "assets/img/reboot.4090c76f.svg";